// extracted by mini-css-extract-plugin
export default {"itens":"itens_itens__vN66t"};